import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const AdminRoute = ({ children }) => {
    const roleList = useSelector((state) => state?.loginReducer?.loginUserInfo);
    const {isSuperAdminLoggedIn} = useSelector((state) => state?.loginReducer);

    if(roleList?.group === 1) { 
      return children;
    } else {
      if(isSuperAdminLoggedIn) {
        return <Navigate to="/super-admin/dashboard" />
      } else {
        return <Navigate to="/home" />
      }
    }
};

export default AdminRoute;